const home = {
  heroAlt: "Profesioniști care analizează planuri la o renovare",
  galleryAlt: "Sectorul construcțiilor și renovărilor",
  install: {
    iosSub: "Descarcă din",
    androidSub: "Disponibil pe",
    iosTitle: "Instalează pe iPhone/iPad",
    iosDesc: "Deschide această pagină în Safari, apasă Partajează și apoi „Adaugă pe ecranul principal”.",
    androidTitle: "Instalează aplicația",
    androidDesc: "Deschide meniul browserului și alege „Instalează aplicația” / „Adaugă pe ecranul de pornire”.",
  },
  apps: {
    nuvliTitle: "Aplicația mobilă NuvliPro",
    nuvliDesc: "Oferte, facturi, șantiere, cheltuieli și evidența programului de lucru pe telefonul tău.",
    nuvliInstall: "Descarcă NuvliPro",
    nuvliNote: "Instalare directă (PWA) · funcționează pe Android și iPhone, fără să ocupe spațiu.",
    workerTitle: "Aplicația mobilă Pontaj GPS",
    workerDesc: "Pentru angajați: pontaj la intrare/ieșire cu GPS și autentificare cu cod de acces.",
    workerInstall: "Descarcă Pontaj GPS",
    workerNote: "Pentru muncitori · după instalare, deschide aplicația și autentifică-te cu codul de acces.",
    workerCta: "Deschide aplicația pentru angajați",
    qrTitle: "Pontaj cu GPS",
    qrSubtitle: "Pontaj simplu și sigur pentru echipa ta",
    qrText: "Descarc-o gratuit de pe site-ul nostru",
    qrInstall: "Instalează pe telefon",
    qrAvailable: "Disponibilă pentru Android și iPhone",
  },
  login: {
    title: "Autentificare", email: "E-mail", password: "Parolă", emailPh: "tu@email.com", submit: "Intră",
    forgot: "Ți-ai uitat parola?", register: "Înregistrează-te gratuit", welcome: "Bine ai venit", error: "Autentificarea a eșuat",
  },
  features: {
    badge: "Funcționalități",
    title: "Tot ce ai nevoie pentru a-ți gestiona afacerea",
    items: [
      { t: "Facturare", d: "Facturi cu numerotare automată, TVA și rețineri, stări și descărcare în PDF profesional." },
      { t: "Oferte", d: "Oferte pe capitole și articole descriptive; transformă-le în factură cu un clic." },
      { t: "Controlul cheltuielilor", d: "Înregistrează materiale, manoperă și aprovizionări; urmărește cheltuielile pe șantier și categorie." },
      { t: "Încasări parțiale", d: "Înregistrează avansuri, urmărește soldul de încasat și trimite chitanțe automat." },
      { t: "Rapoarte trimestriale", d: "TVA și impozit pe venit pe trimestru, gata pentru contabilul tău și exportabile în PDF și Excel." },
      { t: "Gestionarea clienților", d: "Fișă completă pentru fiecare client, istoricul documentelor și detectarea restanțelor." },
    ],
  },
  pricing: {
    badge: "Planuri și prețuri",
    title: "Alege planul potrivit pentru afacerea ta",
    subtitle: "Începe gratuit, fără dată de încheiere. Treci la un plan superior când ai nevoie: fără obligații, anulezi oricând.",
    freeCta: "Creează un cont gratuit",
    labels: { gratuito: "Plan Gratuit", trimestral: "Plan Trimestrial", anual: "Plan Anual" },
    perMonth: "{{amount}}/lună",
    approx: "≈ {{amount}}/lună",
    periodo: { gratuito: "Fără dată de încheiere", trimestral: "{{total}} la fiecare 3 luni", anual: "{{total}} pe an" },
    nota: { gratuito: "Pentru a începe fără să plătești", trimestral: "Fără limite, cu plată la fiecare 3 luni", anual: "O singură plată pe an" },
    badges: { trimestral: "Cel mai popular" },
    save: "Economisești {{amount}}/an",
    features: {
      gratuito: ["Până la 8 clienți", "Până la 8 oferte", "Facturare și încasări parțiale pentru cei 8 clienți", "Cheltuieli și trimestrial: ultimele 2 trimestre", "2 proiecte de șantier", "Pontaj cu muncitori nelimitați"],
      trimestral: ["Clienți, oferte și șantiere nelimitate", "Istoric complet al cheltuielilor și trimestrelor", "IA, VeriFactu și reconciliere bancară", "Mementouri prin e-mail și WhatsApp", "Export pentru contabilul tău"],
      anual: ["Tot ce include planul Trimestrial", "Documente și logo personalizate", "Alerte automate programate", "Suport prioritar"],
    },
    payCard: "Plătește cu cardul",
    payNote: "Card: reînnoire automată, anulezi oricând",
    footnote: "Prețuri fără TVA · Plată cu cardul · Plată securizată prin Stripe",
    approxNote: "Echivalent aproximativ în {{currency}} la cursul de schimb al zilei. Suma exactă apare pe pagina de plată.",
    payError: "Plata nu a putut fi inițiată",
  },
  trust: {
    title: "Profesioniști care au deja încredere în NuvliPro",
    subtitle: "Păreri reale de la firme din sectorul construcțiilor și renovărilor.",
    testimonials: [
      { cargo: "Director General", empresa: "Constructora MendozaBuild S.A.", texto: "Am lucrat peste un deceniu cu Excel și sisteme care nu comunicau între ele. Cu NuvliPro am adunat toate informațiile celor 8 proiecte ale noastre și am redus timpul de administrare cu 60%. Rapoartele de profitabilitate pe proiect sunt acum precise și iau decizii pe baza datelor reale, nu a intuiției." },
      { cargo: "Directoare de Proiecte", empresa: "Grupo Constructor Rojas & Asociados", texto: "Am trecut de la 3 la 12 proiecte active, iar sistemul nostru manual s-a prăbușit. Cu NuvliPro am crescut fără să dublăm personalul administrativ: trasabilitate completă a fiecărui material, controlul subcontractorilor în timp real și cu 75% mai puțină documentație finală. Clienții noștri primesc rapoarte care inspiră încredere." },
      { cargo: "Proprietar Independent", empresa: "18 ani în domeniu", texto: "Lucrările mele erau tot mai complexe și mai puțin profitabile, iar costurile îmi scăpau fără să știu unde. Cu NuvliPro am identificat pierderile financiare, am consolidat furnizorii și am redus costurile generale cu 22% fără să sacrific calitatea. Acum fac oferte mai detaliate în mai puțin timp și închei mai multe proiecte." },
    ],
    seals: [
      { t: "Conform GDPR", d: "Date protejate" },
      { t: "Criptare SSL", d: "Conexiune sigură" },
      { t: "Plăți cu Stripe", d: "Încasări protejate" },
      { t: "Suport în spaniolă", d: "Oricând ai nevoie" },
    ],
  },
  demo: {
    badge: "Video demo",
    title: "Descoperă NuvliPro în 2 minute",
    subtitle: "Vezi cum creezi o ofertă, o transformi în factură și ții evidența încasărilor și cheltuielilor.",
    unsupported: "Browserul tău nu acceptă redarea video.",
    soon: "Video demo în curând",
  },
  faq: {
    badge: "Întrebări frecvente",
    title: "Îți răspundem la întrebări",
    items: [
      { q: "Am nevoie de cunoștințe de contabilitate pentru a folosi NuvliPro?", a: "Nu. NuvliPro este gândit pentru liber-profesioniști și firme mici: creezi oferte și facturi completând câmpuri clare, iar aplicația calculează automat TVA-ul, reținerile și totalurile." },
      { q: "Pot să-l încerc gratuit?", a: "Da. Planul Gratuit nu expiră și nu necesită card: până la 8 clienți, 8 oferte, 8 facturi și 1 proiect de șantier activ. Când ai nevoie de mai mult, treci la un plan plătit." },
      { q: "Datele clienților mei sunt în siguranță?", a: "Da. Criptăm conexiunea (SSL), respectăm GDPR, iar plățile sunt gestionate în siguranță prin Stripe. Nu îți partajăm niciodată datele." },
      { q: "Pot să-mi personalizez facturile și ofertele cu logo-ul meu?", a: "Da. Din Zona personală poți încărca logo-ul firmei și poți alege designul documentului astfel încât să reflecte brandul tău." },
      { q: "NuvliPro ajută la controlul trimestrial al impozitelor?", a: "Da. Generează automat rezumatul TVA colectat/deductibil și al impozitului pe venit pe trimestru, exportabil în PDF și Excel pentru contabilul tău." },
      { q: "Pot anula oricând?", a: "Desigur. Nu există obligații: îți poți schimba sau anula planul oricând din contul tău." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "Vorbim?",
    subtitle: "Spune-ne de ce ai nevoie și îți răspundem cât mai repede. Suntem aici să te ajutăm să profiți la maximum de NuvliPro.",
    support: "Asistență clienți",
    supportNote: "Suport în spaniolă · răspuns în 24-48 h",
    name: "Nume", namePh: "Numele tău", email: "E-mail", emailPh: "tu@email.com",
    message: "Mesaj", messagePh: "Cu ce te putem ajuta?", send: "Trimite mesajul",
    sent: "Mesaj trimis! Îți răspundem în curând.", error: "Mesajul nu a putut fi trimis",
  },
  cta: {
    title: "Toată afacerea ta, într-un singur loc",
    items: ["Clienți", "Oferte", "Facturare", "Încasări parțiale", "Cheltuieli", "Trimestrial", "Restanțe", "WhatsApp"],
    button: "Creează-mi contul gratuit",
  },
  footer: "Gestiune completă pentru profesioniștii din construcții și renovări",
};
export default home;
